import React, { useState } from "react";
import { toast } from "sonner";
import { goTo } from "../../../App";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../../ui/dialog";

// Pop-up opt-in riutilizzabile (hero + copertina VSL)
export default function LeadPopup({ open, onOpenChange }) {
  const [form, setForm] = useState({ nome: "", email: "", whatsapp: "" });
  const [consent, setConsent] = useState(false);
  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    if (!form.nome || !form.email || !form.whatsapp) {
      toast.error("Compila tutti i campi.");
      return;
    }
    if (!consent) {
      toast.error("Accetta per ricevere le informazioni.");
      return;
    }
    // MOCK frontend: salva l'opt-in nel browser (backend/CRM da collegare)
    const list = JSON.parse(localStorage.getItem("hts_optin") || "[]");
    list.push({ ...form, ts: new Date().toISOString() });
    localStorage.setItem("hts_optin", JSON.stringify(list));
    toast.success("Perfetto! Ti reindirizzo alla lezione.");
    onOpenChange(false);
    setTimeout(() => goTo("prodotti"), 300);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" style={{ background: "#0C0C0F", border: "1px solid rgba(255,255,255,0.1)", color: "#F4F3F6" }}>
        <DialogHeader>
          <DialogTitle className="v-serif" style={{ fontSize: "1.8rem", fontStyle: "italic", fontWeight: 400 }}>Scopri il processo</DialogTitle>
          <DialogDescription className="v-sans" style={{ color: "#98959F" }}>
            Lasciami i tuoi contatti e ti porto subito alla lezione.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="grid gap-3 mt-1">
          <input className="field" placeholder="Nome" value={form.nome} onChange={upd("nome")} />
          <input className="field" type="email" placeholder="Email" value={form.email} onChange={upd("email")} />
          <input className="field" type="tel" placeholder="WhatsApp" value={form.whatsapp} onChange={upd("whatsapp")} />
          <label className="flex items-start gap-2 cursor-pointer" style={{ fontSize: "0.82rem", color: "#98959F" }}>
            <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} style={{ marginTop: 3, width: 16, height: 16, accentColor: "#2E6BFF" }} />
            Accetto di ricevere informazioni e ho letto la Privacy Policy.
          </label>
          <button type="submit" className="v-btn v-btn-blue w-full mt-1">Guarda la lezione</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
